import type { RouteLocationNamedRaw, Router } from 'vue-router'

import { resolveChatMessagingUiEnabled } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { getChatRoute, type ChatRouteSource } from '@/shared/utils/url'

const mainRoute: RouteLocationNamedRaw = { name: pathNames.MAIN }

let appRouter: Router | null = null

/** Bound from app router bootstrap to avoid static `@/app/router` import cycles. */
export const setNavigateFromEndedCallRouter = (router: Router): void => {
  appRouter = router
}

const getRouter = (): Router => {
  if (!appRouter) {
    throw new Error('Router is not bound for navigateFromEndedCall')
  }
  return appRouter
}

export const navigateFromEndedCall = (room?: ChatRouteSource | null) => {
  const router = getRouter()
  const chatRoute = room ? getChatRoute(room) : undefined
  if (chatRoute && resolveChatMessagingUiEnabled()) {
    return router.push(chatRoute)
  }

  return router.push(mainRoute)
}

export const leaveCallSessionRouteIfCurrent = (sessionId: string) => {
  const router = getRouter()
  const { name, params } = router.currentRoute.value
  if (params.sessionId !== sessionId) {
    return Promise.resolve()
  }

  if (name === pathNames.CALL_SESSION) {
    return router.push(mainRoute)
  }

  if (name === pathNames.GUEST_CALL_SESSION) {
    return Promise.resolve(router.back())
  }

  return Promise.resolve()
}
